var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormFields',{attrs:{"form":_vm.form,"render":_vm.formRender,"lang-path":"base.bank_account."}})}
var staticRenderFns = []

export { render, staticRenderFns }